module.exports = __webpack_public_path__ + "img/arrow-ios-upward.ca10346c.svg";